import React, { Component } from 'react';
import styles from './cmsDeviceComands.module.scss';
import { withCurrentDevices } from '../../../../shared/containers/containerCurrentDevice';
import { TextField } from '@mui/material';
import ButtonPrimary from '../../../../shared/items/contols/buttonPrimary';
import { states } from '../../../../reducers/queriesStates';
import DeleteIcon from '@mui/icons-material/Delete';
import { NULL } from 'sass';

class CmsDeviceComands extends Component {
  constructor(props) {
    super(props);

    this.state = {
      command: '',
      resultMessage: null,
    };
  }

  componentDidMount() {
    const { currentDevice } = this.props;

    if (currentDevice !== null) {
      this.setState({ command: currentDevice.command });
    }
  }

  componentDidUpdate(preProps) {
    const { deleteCommandDataState, createCommandDataState } = this.props;

    if (
      deleteCommandDataState === states.READY &&
      preProps.deleteCommandDataState === states.REQUEST
    ) {
      this.setState({
        command: '',
        resultMessage: 'Команда успешно удалена',
      });
    }

    if (
      deleteCommandDataState === states.FAILURE &&
      preProps.deleteCommandDataState === states.REQUEST
    ) {
      this.setState({
        command: '',
        resultMessage: 'Команда не удалена',
      });
    }

    if (
      createCommandDataState === states.READY &&
      preProps.createCommandDataState === states.REQUEST
    ) {
      this.setState({
        resultMessage: 'Команда успешно добавлена',
      });
    }

    if (
      createCommandDataState === states.FAILURE &&
      preProps.createCommandDataState === states.REQUEST
    ) {
      this.setState({
        resultMessage: 'Команда не добавлена',
      });
    }
  }

  onClickUpdateHandler() {
    const { currentDevice, onCreateCommand } = this.props;
    const { command } = this.state;

    onCreateCommand(currentDevice.id, { command });
  }

  onClickDeleteHandler() {
    const { currentDevice, onDeleteCommand } = this.props;

    onDeleteCommand(currentDevice.id);
  }

  render() {
    const { currentDevice } = this.props;
    const { command, resultMessage } = this.state;

    if (
      currentDevice === null ||
      (currentDevice.type !== 1 && currentDevice.type !== 16)
    )
      return <div></div>;

    return (
      <div className={styles.cmsDeviceCommandContainer}>
        <div className={styles.updateToolContainer}>
          <TextField
            disabled={currentDevice.command !== null}
            value={command}
            id="outlined-basic"
            label="Команда"
            variant="outlined"
            size="small"
            type="text"
            onChange={(e) => {
              this.setState({ command: e.target.value });
            }}
          />

          {currentDevice.command === null ? (
            <ButtonPrimary
              disabled={command === null || command.length === 0}
              title={'Задать команду'}
              handleClick={this.onClickUpdateHandler.bind(this)}
            />
          ) : (
            <DeleteIcon
              fontSize="large"
              onClick={this.onClickDeleteHandler.bind(this)}
            />
          )}
        </div>
        <div>
          <b> {resultMessage}</b>
        </div>
      </div>
    );
  }
}

export default withCurrentDevices(React.memo(CmsDeviceComands));
